import { render, staticRenderFns } from "./StyleList.vue?vue&type=template&id=1ec8e2c0"
import script from "./StyleList.vue?vue&type=script&lang=ts"
export * from "./StyleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports